// extracted by mini-css-extract-plugin
module.exports = {"restrictedWidthSectionHeader":"style-module__restrictedWidthSectionHeader___3AjSG"};